import { Link } from "react-router-dom";
import { buttonVariants } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/lib/auth-context";
import { getListUrl } from "@/lib/use-grid-preferences";

interface ListBackButtonProps {
  to: string;
  label?: string;
  /** Storage key override for school-scoped pages (e.g. "events" for /schools/:id/events) */
  pageKey?: string;
}

export function ListBackButton({ to, label, pageKey }: ListBackButtonProps) {
  const { user } = useAuth();
  const url = getListUrl(to, user?.user.id, pageKey);

  return (
    <Link
      to={url}
      className={buttonVariants({ variant: "ghost", size: "sm" }) + " -ml-2 w-fit text-muted-foreground"}
    >
      <ArrowLeft className="mr-1 h-4 w-4" />
      {label ?? "Back"}
    </Link>
  );
}
